import useSWR from "swr";
import { isEmpty } from "lodash";
import Link from "next/link";

import {
  Card
} from "antd";

import styles from "components/blog/categories/BlogCategories.module.scss";

const BlogCategories = ({ activeCategoryId }) => {
  const { data: categories } = useSWR("/api/lib/v1/blogs/categories", (url) =>
    fetch(url).then((r) => r.json())
  );
  if (isEmpty(categories)) {
    return null;
  }
  return (
    <Card
      title="Kategórie blogov"
      className={styles.blogCategories}
    >
      <ul>
        <li key={`blog-category-all`}>
          <Link href="/blog">
            <a className={!activeCategoryId ? styles.active : ''}>Všetky blogy a články</a>
          </Link>
        </li>
        {categories.map((category) => (
          <li key={`blog-category-${category?.id}`}>
            <Link
              href="/blog/kategoria/[id]/[[...category]]"
              as={`/blog/kategoria/${category?.id}/${category?.urlName}`}
            >
              <a
                className={
                  activeCategoryId == category?.id ? styles.active : ""
                }
              >
                {category?.name}
              </a>
            </Link>
          </li>
        ))}
      </ul>
    </Card>
  )
};

export default BlogCategories;
